import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

export const getNotificationDocsNo = async (
  notificationDocsNo: string,
  yearMonth: string
) => {
  const path = `/notification_docs/${encodeURIComponent(
    notificationDocsNo
  )}?year_month=${yearMonth}`;
  const params = {};
  let result: any;
  await API.get(API_NAME, path, params)
    .then((response) => {
      result = response;
    })
    .catch((e) => {
      console.error(e);
      result = e.response.data;
    });
  return result;
};
